<template>
  <v-card flat>
    <h1>{{ $t('application.instructor.thanks.title') }}</h1>
    <p>{{ $t('application.instructor.thanks.info1') }}</p>

    <MessageBox class="mt-3" type="info">
      <h6 class="pb-4 title text-uppercase">{{ $t('application.thanks.boxTitle') }}</h6>
      <p>{{ $t('application.instructor.thanks.boxInfo') }}</p>

      <p>
        <a :href="links.application.thankYou">{{ $t('application.instructor.thanks.boxLink') }}</a>
      </p>
    </MessageBox>
    <!-- push user to homepage , application is submited -->
    <NextButton @click="goHome" class="mt-8">{{ $t('application.thanks.close') }}</NextButton>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import API from '@/services/api.js'
import MessageBox from '@/components/Common/MessageBox'
import NextButton from '@/components/Common/NextButton'
// @group Application-Company
// ApplicationThanks component
export default {
  name: 'ApplicationThanks',
  data() {
    return {
      links:require('../../../lib/external-links.json')
    }
  },
  components: {
    MessageBox,
    NextButton
  },

  computed: {
    ...mapGetters('application', ['currentStep', 'selectedApplication'])
  },
  methods: {
    ...mapActions('application', ['setSelectedApplication']),

    /**
     * @vuese
     * Used to push user to homepage ,end of application
     */
    goHome() {
      this.setSelectedApplication({})
      this.$router.push('/').catch(() => {})
    }
  }
}
</script>
